module.exports = __webpack_public_path__ + "static/media/21-4.a501377c.mp3";